(() => {
  const runtime = window.BogerSections;
  if (!runtime) return;
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const findFollowing = (root, selector) => {
    let section = root.closest('.shopify-section')?.nextElementSibling;
    while (section) {
      const match = section.matches?.(selector) ? section : section.querySelector?.(selector);
      if (match) return match;
      section = section.nextElementSibling;
    }
    return document.querySelector(selector);
  };

  runtime.register('walk-profile', '[data-profile-form]', (form, { signal }) => {
    const error = form.querySelector('.profile-error');
    const labels = {
      'walk-context': { neighbourhood: 'Neighbourhood', park: 'Park', trips: 'Trips' },
      'carry-needs': { rewards: 'Rewards', water: 'Water', balanced: 'Balanced' },
      'walk-length': { short: 'Short', everyday: 'Everyday', long: 'Longer' }
    };
    const resultParts = () => {
      const result = findFollowing(form, '[data-profile-result]');
      if (!result) return null;
      const roles = Object.fromEntries([...result.querySelectorAll('[data-v2-profile-role]')].map(node => [node.dataset.key, [node.dataset.name, node.dataset.detail]]));
      return {
        result,
        empty: result.querySelector('[data-profile-empty]'),
        complete: result.querySelector('[data-profile-complete]'),
        title: result.querySelector('[data-profile-title]'),
        copy: result.querySelector('[data-profile-copy]'),
        priorities: result.querySelector('[data-profile-priorities]'),
        context: result.querySelector('[data-summary-context]'),
        carry: result.querySelector('[data-summary-carry]'),
        length: result.querySelector('[data-summary-length]'),
        roles
      };
    };
    const setState = (parts, state) => {
      parts.result.dataset.state = state;
      if (parts.empty) parts.empty.hidden = state !== 'empty';
      if (parts.complete) parts.complete.hidden = state !== 'complete';
    };
    const orderFor = values => {
      const carry = values.get('carry-needs'), context = values.get('walk-context'), length = values.get('walk-length');
      const order = ['connect'];
      if (carry === 'water') order.push('hydrate');
      else if (carry === 'rewards') order.push('reward');
      else order.push(context === 'trips' || length === 'long' ? 'hydrate' : 'reward');
      if (context === 'neighbourhood' && !order.includes('clean')) order.push('clean');
      if ((length === 'long' || context === 'trips') && !order.includes('hydrate')) order.push('hydrate');
      if (context === 'park' && !order.includes('reward')) order.push('reward');
      ['reward', 'hydrate', 'clean'].forEach(role => { if (!order.includes(role)) order.push(role); });
      return order;
    };
    form.querySelectorAll("input[type='radio']").forEach(input => input.addEventListener('change', () => {
      input.closest('fieldset')?.removeAttribute('aria-invalid');
      if (![...form.querySelectorAll('fieldset')].some(field => field.getAttribute('aria-invalid') === 'true') && error) error.textContent = '';
    }, { signal }));
    form.addEventListener('submit', event => {
      event.preventDefault();
      const parts = resultParts();
      if (!parts) { if (error) error.textContent = 'The result section is unavailable. Add or show the Walk profile result section, then try again.'; return; }
      const values = new FormData(form), required = ['walk-context', 'carry-needs', 'walk-length'];
      const missing = required.filter(name => !values.get(name));
      form.querySelectorAll('fieldset').forEach(field => {
        const name = field.querySelector("input[type='radio']")?.name;
        field.toggleAttribute('aria-invalid', Boolean(name && missing.includes(name)));
      });
      if (missing.length) {
        if (error) error.textContent = 'Choose one option in each highlighted group, then arrange your priorities.';
        setState(parts, 'empty');
        form.querySelector(`input[name='${missing[0]}']`)?.focus();
        return;
      }
      if (error) error.textContent = '';
      const context = values.get('walk-context'), carry = values.get('carry-needs'), length = values.get('walk-length');
      if (parts.title) parts.title.textContent = context === 'trips' ? 'An order for trips' : context === 'park' ? 'An order for park walks' : 'An order for neighbourhood walks';
      if (parts.copy) parts.copy.textContent = 'This order comes only from the three choices shown below. It does not choose a harness size.';
      if (parts.context) parts.context.textContent = labels['walk-context'][context];
      if (parts.carry) parts.carry.textContent = labels['carry-needs'][carry];
      if (parts.length) parts.length.textContent = labels['walk-length'][length];
      if (parts.priorities) {
        parts.priorities.replaceChildren();
        orderFor(values).forEach(key => {
          const role = parts.roles[key] || [key, 'Role detail is not configured.'];
          const item = document.createElement('li'), name = document.createElement('strong'), detail = document.createElement('span');
          name.textContent = role[0]; detail.textContent = role[1]; item.append(name, detail); parts.priorities.append(item);
        });
      }
      setState(parts, 'complete');
      parts.result.focus({ preventScroll: true });
      parts.result.scrollIntoView({ block: 'start', behavior: reduce() ? 'auto' : 'smooth' });
    }, { signal });
    form.addEventListener('reset', () => {
      if (error) error.textContent = '';
      form.querySelectorAll('fieldset').forEach(field => field.removeAttribute('aria-invalid'));
      const parts = resultParts();
      if (parts) setState(parts, 'empty');
    }, { signal });
  });

  runtime.register('walk-local-frame', '[data-community-form]', (form, { signal }) => {
    const file = form.elements.image, consent = form.elements.consent;
    const error = form.querySelector('.form-error'), status = form.querySelector('[data-community-status]');
    const fileName = form.querySelector('[data-file-name]');
    const stage = form.closest('.v33-frame-layout');
    const preview = stage?.querySelector('[data-community-preview]'), empty = stage?.querySelector('[data-community-empty]');
    const remove = form.querySelector('[data-preview-remove]');
    if (!file || !consent || !preview || !empty) return;
    let objectUrl = '';
    const clear = () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      objectUrl = '';
      preview.hidden = true;
      preview.removeAttribute('src');
      empty.hidden = false;
      if (remove) remove.disabled = true;
      if (fileName) fileName.textContent = 'No image selected';
      if (status) { status.dataset.state = ''; status.textContent = 'No image is being previewed.'; }
    };
    file.addEventListener('change', () => {
      if (fileName) fileName.textContent = file.files[0]?.name || 'No image selected';
      if (status) status.textContent = file.files[0] ? 'Image selected. Confirm permission, then show the local preview.' : 'No image is being previewed.';
    }, { signal });
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (error) error.textContent = '';
      const selected = file.files[0];
      if (!selected) { if (error) error.textContent = 'Choose a JPG, PNG or WebP image first.'; file.focus(); return; }
      if (!['image/jpeg', 'image/png', 'image/webp'].includes(selected.type) || selected.size > 10 * 1024 * 1024) { if (error) error.textContent = 'Choose a JPG, PNG or WebP image no larger than 10MB.'; file.focus(); return; }
      if (!consent.checked) { if (error) error.textContent = 'Confirm that you own the image or have permission to use it.'; consent.focus(); return; }
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      objectUrl = URL.createObjectURL(selected);
      preview.src = objectUrl;
      preview.hidden = false;
      empty.hidden = true;
      if (remove) remove.disabled = false;
      if (status) { status.dataset.state = 'success'; status.textContent = `${selected.name} is shown only in this browser view. It was not uploaded or saved.`; status.focus(); }
    }, { signal });
    form.addEventListener('reset', () => queueMicrotask(clear), { signal });
    return clear;
  });
})();
